/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_Tx_RentInputs */

const cs_public_site_demand_tx_rent = /** @type {(inputs: Public_Site_Demand_Tx_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronájem`)
};

const en_public_site_demand_tx_rent = /** @type {(inputs: Public_Site_Demand_Tx_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent`)
};

/**
* | output |
* | --- |
* | "Rent" |
*
* @param {Public_Site_Demand_Tx_RentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_tx_rent = /** @type {((inputs?: Public_Site_Demand_Tx_RentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_Tx_RentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_tx_rent(inputs)
	return cs_public_site_demand_tx_rent(inputs)
});